import { EVENT_ALBUM_EVENTS } from 'Sp/Angular/Events/Client/Gallery';
import Route from 'Sp/Route';

export default [
    '$rootScope',
    'spApiHttp',
    function EventAlbumDataStore($rootScope, spApiHttp) {
        let albumData;

        $rootScope.$on(EVENT_ALBUM_EVENTS.GET, function withId(_, id) {
            if (
                albumData &&
                albumData.id === Number(id) &&
                albumData.eventId === Number($rootScope.eventData.id)
            ) {
                $rootScope.$broadcast(EVENT_ALBUM_EVENTS.GOT, albumData);
                return;
            }

            const eventId = $rootScope.eventData.publicId
                ? $rootScope.eventData.publicId
                : $rootScope.eventData.id;

            spApiHttp
                .get(
                    Route.get('/brand/:brandId/event/:eventId/album/:id', {
                        brandId: $rootScope.brandData.id,
                        eventId,
                        id
                    })
                )
                .then(function withResponse({ data: eventAlbum }) {
                    albumData = eventAlbum;
                    $rootScope.$broadcast(EVENT_ALBUM_EVENTS.GOT, eventAlbum);
                });
        });
    }
];
